import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

export const COOKIE_CONSENT_USER_ACCEPTED = 'cookie_consent_user_accepted';
export const COOKIE_CONSENT_LEVEL = 'cookie_consent_level';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  standalone: false,
})
export class CookieBannerComponent implements OnInit {
  isVisible: boolean = false;
  showPreferences: boolean = false;

  // Cookie preference categories
  analyticsCookies: boolean = true;
  marketingCookies: boolean = true;

  constructor(private cookieService: CookieService) {}

  ngOnInit(): void {
    this.checkConsent();
  }

  checkConsent(): void {
    const isAccepted = this.cookieService.check(COOKIE_CONSENT_USER_ACCEPTED);
    this.isVisible = !isAccepted;
  }

  acceptAll(): void {
    this.saveConsentState(true, true);
  }

  acceptNecessary(): void {
    this.analyticsCookies = false;
    this.marketingCookies = false;
    this.saveConsentState(false, false);
  }

  openPreferences(): void {
    this.showPreferences = true;
  }

  closePreferences(): void {
    this.showPreferences = false;
  }

  savePreferences(): void {
    this.saveConsentState(this.analyticsCookies, this.marketingCookies);
  }

  private saveConsentState(analytics: boolean, marketing: boolean): void {
    const consentLevel = {
      'strictly-necessary': true,
      functionality: true,
      tracking: analytics,
      targeting: marketing,
    };

    // Set cookie for 1 year (365 days)
    this.cookieService.set(COOKIE_CONSENT_USER_ACCEPTED, 'true', { expires: 365, path: '/' });
    this.cookieService.set(COOKIE_CONSENT_LEVEL, JSON.stringify(consentLevel), { expires: 365, path: '/' });

    this.isVisible = false;
    this.showPreferences = false;
  }
}
